export default "__VITE_ASSET__rmyK6PAF__"